import { ReactNode } from 'react'

import { Helmet } from 'react-helmet-async'

import {
  Box, Columns,
} from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'

import { UseCampaignPayload } from '@hooks/useCampaign'
import useCurrentUser from '@hooks/useCurrentUser'

import { getCampaignPermissions, getCampaignType } from '@functions/campaign'
import propertyDetailsTabBarItems from '@sections/Client/packs/Campaign/utils/generatePropertyDetailsTabBarItems'

import PublishCampaignButton from '@components/PublishCampaignButton'

interface PageLayoutProps {
  children: ReactNode,
  campaignPayload: UseCampaignPayload,
}

const PageLayout = (props: PageLayoutProps) => {
  const { children, campaignPayload } = props

  const {
    campaign, campaign: { address, id },
  } = campaignPayload

  const { currentUser } = useCurrentUser()

  const campaignPermissions = getCampaignPermissions({ user: currentUser, campaignType: getCampaignType(campaign) })

  return (
    <>
      <Helmet>
        <title>{address || 'Campaign'} | Portals</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <PublishCampaignButton campaignPayload={campaignPayload} />
        )}
        activeTabBarItemKey="portals"
        nestedNavigation
        showBackButton
        tabBarItems={propertyDetailsTabBarItems(id, campaignPermissions)}
        title="Portals"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
